import React from "react";
import { useSearchParams } from "react-router-dom";
import GetAffiliateItems from "../utils/GetAffiliateItems";

const useKioskMode = () => {
  const [searchParams] = useSearchParams();

  const [isKiosk, setMode] = React.useState(false);
  const [specialAffiliate, setSpecial] = React.useState(null);

  React.useEffect(() => {
    const aid = searchParams.get("scaaf_aid") || localStorage.getItem("scaaf_aid");

    if (aid) {
      localStorage.setItem("scaaf_aid", aid);
      setMode(true);

      GetAffiliateItems().then((items) => {
        const value = items?.find((item) => item.link.includes(aid)) ?? {};

        value &&
          setSpecial({
            ...value,
            has_double_patch_points: value?.has_double_patch_points !== "false",
          });
      });
    }
  }, []);

  return { isKiosk, specialAffiliate };
};

export default useKioskMode;
